import http from "@/configs/AxiosConfig";

const api = http;

export default {
  getStats() {
    return api.get("/admin/logs/stats");
  },

  exportLogs(params = {}) {
    return api.get("/admin/logs/export", {
      params,
      responseType: "blob",
    });
  },

  cleanupOldLogs(days = 90) {
    return api.post(`/admin/logs/cleanup?days=${days}`);
  },
};
